import Vue from 'vue'

import toast from './toast'
import resourceTranslations from './resource-translations'

Vue.mixin(toast)
Vue.mixin(resourceTranslations)
